import React from "react";

import { inject, observer } from "mobx-react";

import { PermissionsController } from "../../PermissionsController";
import { Input } from "antd";

@inject("permissionsController")
@observer
export class PermissionSearch extends React.Component<{
  permissionsController?: PermissionsController;
}> {
  public render() {
    const { tableSearch, resetSearchValues } = this.props.permissionsController;

    return (
      <div style={{ padding: 10, background: "#fff", borderBottom: "1px solid #ddd" }}>
        <Input
          placeholder="Type to search for the route by their name"
          onChange={(e) => {
            if (!e.currentTarget.value) {
              resetSearchValues();
            } else {
              this.props.permissionsController.tableSearch = e.currentTarget.value;
            }
          }}
          allowClear={true}
          value={tableSearch}
        />
      </div>
    );
  }
}
